import DashboardLayout from "../../components/layout/DashboardLayout";
import classes from "../../styles/pages/bot/BotAndAutomation.module.css";
import usePageTitle from "../../hooks/usePageTitle";
import BotOverview from "../../components/bot/BotOverview";
import CommunityBots from "../../components/bot/CommunityBots";
import PageHeader from "../../ui/PageHeader";
import { useParams } from "react-router-dom";
import PdfReport from "../../components/bot/PdfReport";

function BotAndAutomation() {
  const { section } = useParams();
  usePageTitle("Bot & Automation");

  return (
    <DashboardLayout hasDemo>
      <PageHeader title="AI Bot" service="bot" />
      {!section && (
        <>
          <div className={classes.main}>
            <BotOverview />
            <CommunityBots />
          </div>
        </>
      )}
      {section === "performance-report" && (
        <PdfReport backPath="/bot-automation" />
      )}
      {section === "backtest-report" && (
        <PdfReport backPath="/bot-automation" />
      )}
      {section === "bot-report" && <PdfReport backPath="/bot-automation" />}
    </DashboardLayout>
  );
}

export default BotAndAutomation;
